/* Vagustim, Research page (Partnerships and clinical trials variants)
   Shared by sections/vagustim-research.liquid and sections/vagustim-research-collab.liquid */
(function () {
  var reduced = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hsQueue = [];

  /* HubSpot renders the form in a same-origin iframe, so page CSS cannot reach it: inject the page's form styles */
  var HS_CSS = [
    "@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400..700&display=swap');",
    'html,body{margin:0;background:transparent}',
    "body,.hs-form,.hs-form *{font-family:'Inter',system-ui,-apple-system,sans-serif!important;-webkit-font-smoothing:antialiased}",
    '.hs-form{display:flex;flex-direction:column;gap:18px;margin:0;color:#0E2A5C}',
    '.hs-form fieldset{max-width:none!important;margin:0;padding:0;border:0;min-width:0}',
    '.hs-form fieldset.form-columns-2,.hs-form fieldset.form-columns-3{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:18px 16px}',
    '.hs-form .hs-form-field{width:auto!important;float:none!important;display:flex;flex-direction:column;gap:8px;margin:0!important;padding:0!important}',
    '.hs-form .input{margin:0!important}',
    '.hs-form .hs-form-field>label{font-size:11px!important;font-weight:600!important;letter-spacing:.14em!important;text-transform:uppercase;color:#4A5468!important;margin:0!important;padding:0!important;line-height:1.4!important}',
    '.hs-form .hs-form-required{color:#2874D8!important;margin-left:2px}',
    '.hs-form legend.hs-field-desc{font-size:13px;line-height:1.45;color:#6B7488;margin:-2px 0 2px;padding:0}',
    '.hs-form .hs-input:not([type=checkbox]):not([type=radio]){box-sizing:border-box;width:100%!important;max-width:none!important;height:50px!important;margin:0;padding:0 16px!important;border-radius:14px!important;border:1px solid rgba(14,42,92,.14)!important;background:#fff!important;color:#0E2A5C!important;font-size:16px!important;line-height:normal!important;box-shadow:none!important;-webkit-appearance:none;appearance:none;transition:border-color .2s,box-shadow .2s}',
    '.hs-form textarea.hs-input{height:auto!important;min-height:130px;padding:14px 16px!important;line-height:1.55!important;resize:vertical}',
    '.hs-form .hs-input::placeholder{color:#8A93A6;opacity:1}',
    '.hs-form .hs-input:focus{outline:none!important;border-color:#2874D8!important;box-shadow:0 0 0 4px rgba(40,116,216,.12)!important}',
    '.hs-form .hs-input.invalid,.hs-form .hs-input.error{border-color:#D14343!important}',
    '.hs-form .inputs-list{list-style:none;margin:0;padding:0;display:flex;flex-direction:column;gap:10px}',
    '.hs-form .inputs-list label{display:flex;align-items:flex-start;gap:10px;font-size:14px;line-height:1.5;color:#4A5468;text-transform:none;letter-spacing:0;font-weight:400}',
    '.hs-form input[type=checkbox],.hs-form input[type=radio]{width:18px;height:18px;margin:2px 0 0;flex:none;accent-color:#2874D8}',
    '.hs-form .hs-error-msgs{list-style:none;margin:2px 0 0;padding:0}',
    '.hs-form .hs-error-msg,.hs-form .hs-error-msgs label,.hs-form .hs-main-font-element{font-size:13px!important;color:#C03535!important;text-transform:none!important;letter-spacing:0!important;font-weight:500!important}',
    '.hs-form .legal-consent-container,.hs-form .hs-richtext{font-size:13px;line-height:1.55;color:#6B7488}',
    '.hs-form .hs_submit{margin:0;padding:0}',
    '.hs-form .hs_submit .actions{margin:4px 0 0!important;padding:0!important;text-align:left!important}',
    '.hs-form .hs-button{display:inline-flex;align-items:center;justify-content:center;height:52px;padding:0 30px!important;border-radius:999px!important;border:0!important;background:#2874D8!important;color:#fff!important;font-size:16px!important;font-weight:500!important;line-height:normal!important;box-shadow:none!important;cursor:pointer;-webkit-appearance:none;appearance:none;transition:background .2s,transform .2s}',
    '.hs-form .hs-button:hover{background:#1F63BD!important}',
    '.hs-form .hs-button:active{transform:scale(.98)}',
    '.submitted-message{padding:20px 22px;border-radius:16px;background:#E8F0FB;color:#0E2A5C;font-size:16px;line-height:1.6}',
    '@media (max-width:640px){.hs-form fieldset.form-columns-2,.hs-form fieldset.form-columns-3{grid-template-columns:minmax(0,1fr)}.hs-form .hs-button{width:100%}}'
  ].join('\n');

  function loadHubspot(cb) {
    if (window.hbspt && window.hbspt.forms) return cb();
    hsQueue.push(cb);
    if (document.getElementById('vgres-hs-script')) return;
    var s = document.createElement('script');
    s.id = 'vgres-hs-script';
    s.src = 'https://js-eu1.hsforms.net/forms/embed/v2.js';
    s.charset = 'utf-8';
    s.async = true;
    s.onload = function () { var q = hsQueue; hsQueue = []; q.forEach(function (f) { f(); }); };
    document.head.appendChild(s);
  }

  function styleHubspot(host) {
    var frame = host.querySelector('iframe');
    var doc = frame && (frame.contentDocument || (frame.contentWindow && frame.contentWindow.document));
    if (!doc || !doc.head) return;
    if (!doc.getElementById('vgres-hs-style')) {
      var st = doc.createElement('style');
      st.id = 'vgres-hs-style';
      st.textContent = HS_CSS;
      doc.head.appendChild(st);
    }
    /* our styles change the form height: keep the iframe matched to its content */
    var fit = function () { frame.style.height = doc.documentElement.scrollHeight + 'px'; };
    setTimeout(fit, 300);
    if (window.ResizeObserver && doc.body && !frame._vgFit) {
      frame._vgFit = new ResizeObserver(fit);
      frame._vgFit.observe(doc.body);
    }
  }

  function init(root) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';

    var motion = root.dataset.motion === 'true' && !reduced;
    if (!motion) root.classList.add('no-motion');
    var qa = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };

    /* in-page anchors (targets can live in the other research section) */
    qa('[data-jump]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        /* "Read published research" lands on the "Grounded in evidence" logo marquee when it is on the page, the study request sits right under it */
        var t = (a.hasAttribute('data-jump-evidence') && document.querySelector('[id^="vagus-logo-marquee-"]')) || document.getElementById(a.getAttribute('href').slice(1));
        if (!t) return;
        e.preventDefault();
        t.scrollIntoView({ behavior: motion ? 'smooth' : 'auto', block: 'start' });
      });
    });

    /* scroll reveal */
    var rv = qa('[data-rv]');
    if (motion && rv.length && 'IntersectionObserver' in window) {
      root.classList.add('rv-on');
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -40px 0px', threshold: 0 });
      rv.forEach(function (el) { io.observe(el); });
    }

    /* study library request: Klaviyo event (a Klaviyo flow on "Requested Study Library" emails the folder link) */
    var lib = root.querySelector('[data-lib]');
    if (lib) {
      var KL_KEY = lib.dataset.klKey || '', KL_LIST = lib.dataset.klList || '';
      var msg = lib.querySelector('[data-lib-msg]'), input = lib.querySelector('input[name="email"]'), btn = lib.querySelector('button[type="submit"]');
      var say = function (t, err) { msg.textContent = t; msg.classList.toggle('is-err', !!err); };
      var klPost = function (path, body) {
        return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(KL_KEY), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
          body: JSON.stringify(body)
        }).then(function (r) { if (!r.ok) throw new Error(r.status); return r; });
      };
      lib.addEventListener('submit', function (e) {
        e.preventDefault();
        var email = (input.value || '').trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          input.setAttribute('aria-invalid', 'true');
          say('Please enter a valid email address.', true);
          input.focus();
          return;
        }
        input.removeAttribute('aria-invalid');
        if (!KL_KEY) { say('The request form is not configured yet. Please write to sales@vagustim.io.', true); return; }
        btn.disabled = true;
        say('Sending…');
        var jobs = [klPost('events', { data: { type: 'event', attributes: {
          properties: { study_library_url: lib.dataset.url || '', page: location.pathname, variant: lib.dataset.variant || '' },
          metric: { data: { type: 'metric', attributes: { name: 'Requested Study Library' } } },
          profile: { data: { type: 'profile', attributes: { email: email, properties: { study_library_requested_at: new Date().toISOString(), study_library_source: location.pathname } } } }
        } } })];
        /* Every requester joins the list: the form states it under the button. An older
           form with an opt-in box only subscribes when the box is ticked. */
        var optIn = lib.querySelector('input[name="consent"]');
        if (KL_LIST && (!optIn || optIn.checked)) {
          jobs.push(klPost('subscriptions', { data: { type: 'subscription', attributes: {
            custom_source: 'Research study library',
            profile: { data: { type: 'profile', attributes: { email: email } } }
          }, relationships: { list: { data: { type: 'list', id: KL_LIST } } } } }).catch(function (err) {
            if (window.console) console.warn('Study library: Klaviyo list subscription failed', err);
          }));
        }
        jobs[0].then(function () {
          lib.classList.add('is-done');
          say('Thank you. The study library is on its way to ' + email + '. If it has not arrived in a few minutes, check your spam folder.');
        }).catch(function () {
          btn.disabled = false;
          say('Something went wrong. Please try again, or write to sales@vagustim.io.', true);
        });
      });
    }

    /* HubSpot inquiry form, loaded when it nears the viewport */
    var hs = root.querySelector('[data-hs]');
    if (hs) {
      var mount = function () {
        loadHubspot(function () {
          hs.innerHTML = '';
          window.hbspt.forms.create({
            region: hs.dataset.region || 'eu1',
            portalId: hs.dataset.portal,
            formId: hs.dataset.form,
            target: '#' + hs.id,
            css: '',
            onFormReady: function () { try { styleHubspot(hs); } catch (e) {} },
            onFormSubmitted: function () { try { styleHubspot(hs); } catch (e) {} }
          });
        });
      };
      if ('IntersectionObserver' in window) {
        var hio = new IntersectionObserver(function (es) {
          if (es[0].isIntersecting) { hio.disconnect(); mount(); }
        }, { rootMargin: '800px 0px' });
        hio.observe(hs);
      } else mount();
    }

    /* mobile bar: hidden over the hero and while the inquiry section is on screen */
    var bar = root.querySelector('[data-mbar]');
    if (bar && 'IntersectionObserver' in window) {
      var state = {};
      var sync = function () { bar.classList.toggle('is-off', !!(state.top || state.inq)); };
      [['top', 'vgres-top'], ['inq', 'vgres-inquiry']].forEach(function (p) {
        var el = document.getElementById(p[1]);
        if (!el) return;
        new IntersectionObserver(function (es) { state[p[0]] = es[0].isIntersecting; sync(); }).observe(el);
      });
    }
  }

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('.vgres'), init);
    /* study library links (e.g. the institution logo marquee CTA) open in a new tab */
    Array.prototype.forEach.call(document.querySelectorAll('[id^="vagus-logo-marquee-"] a[href*="drive.google.com"]'), function (a) {
      a.target = '_blank';
      a.rel = 'noopener';
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
